import React, {useEffect} from 'react';

import {useChatStore} from '../../store/slices/chatStore';
import {useInteractionStore} from '../../store/slices/interactionStore';
import {startScrollingChat} from '../../utils';
import {MessageItem} from '../Messages/MessageItem';
import './MainContent.style.scss';

const MainContent = () => {
  const messages = useChatStore((state) => state.messages);
  const dotTyping = useInteractionStore((state) => state.dotTyping);

  useEffect(() => {
    if (document.querySelector('.chat-box')) {
      startScrollingChat(0);
    }

    let input = document.getElementById('message');
    if (input) input.focus();
  }, [messages, dotTyping]);

  return (
    <div className="chat-box" data-testid="chat-box-all-messages">
      {messages.map((message) => (
        <MessageItem key={message.id} message={message} />
      ))}

      {dotTyping && <div className="spacing" />}
    </div>
  );
};

export default MainContent;
